


export default {
	website: {

		owner: {
			name: "Kazuto"
		},

		name: "WeebCity",

		donation: {
			qr: {
				code: "3BAr1xT3wd6EU2EVHdY8x53Z9pGtAuSQRm",
				image: "https://cdn.discordapp.com/attachments/693917284124590150/803333760263258153/download.png"
			},
			enabled: false
		}

	},
	api: {

		//imageBase: "http://localhost:3001/",
		//imageBase: "https://ani-cdn.api-web.site/",
		imageBase: "https://api.hianimeto.site/",

		token: "YopgjtY0CA0q6a7NX1Oe",

		proxy: {

			base: "https://api.hianimeto.site/",
			vidstreaming: "https://yare3.yare.wtf"

			//base: "http://192.168.86.58:3011",
			//vidstreaming: "http://localhost:3006",

			//base: "https://ani.api-web.site",
			//base: "https://api.animeheaven.site"

		}

	},

	header: { // SEO spot you can change these no problem!
		baseItems: [
			{
				name: "Anime",
				path: "/anime"
			},
			{
				name: "Movies",
				path: "/browse/?type=movie"
			},
			{
				name: "Dubbed",
				path: "/browse/?language=dubbed"
			},
			{
				name: "Ongoing",
				path: "/browse/?status=current"
			},
			{
				name: "Popular",
				path: "/browse/?sort=popular-all-time"
			},
			{
				name: "Schedule",
				path: "https://anichart.net/airing"
			},
		]
	},

	footer: { // here too, just put the text you want, I designed this so you can use it :)
		section1: [
			{
				path: "https://weebcity.club",
				name: "Anime Online"
			},
			{
				path: "https://weebcity.club",
				name: "Watch Anime"
			},
			{
				path: "https://weebity.club",
				name: "Weebcity"
			},
			{
				path: "https://weebcity.club",
				name: "Weebcity"
			},
			{
				path: "https://weebcity.club",
				name: "Watch Anime Online"
			},
			
		],

		section2: [
			{
				path: "/assets/sitemaps/sitemap0.xml",
				name: "",
				target: "_blanc"
			},
			{
				path: "/assets/sitemaps/sitemap1.xml",
				name: "",
				target: "_blanc"
			},
			{
				path: "/assets/sitemaps/sitemap2.xml",
				name: "",
				target: "_blanc"
			},
			{
				path: "/keywords",
				name: ""
			}
		]
	},

	ads: { // easily control ads
		// old: //cuttuberaxis.com/r3O5xhB4agoUEhK/34523 net ads
		link1: "", // galaksion...


		//
		// old: /*<![CDATA[/* */
		//	(function(){var e1b0eec0a49e906baa43765584841e2e="Eem9l-uHcSJZsu2a2fiiCSegijiNde63hnQeK67hzr9pkUWLA9zTXtjvKJphCxSUgzaLu5Os91JQll8x1IDq";var b=['c8OyCS4=','JRXDoRw=','K8KUXnPDgFfChA==','C8KnCMKGw4wcY2pSTA/Cm8OUw43DuMKMwocYXhYlwq/Dpg==','CCzDm8KZwqhew6zClhPCsDvDpSw=','EcKVwojCl8Ovw6bDqMOY','YlQHw6jDosKaBA==','w6XDlcKawohF','w5t6LmvDgMOIwofCgU9Tw69a','QiB5w6zCuno=','NgtQ','wovCvCbCpibCmsOWK8OPdR0LwppNw6g=','w65pwpbCh3TCvw==','w6HCj8Oif0opdxFEwpBlwq4=','w6xWw6kKworCpcKOdg==','OAvDjsOxw41vNMOAHjEuwp0=','GMK+F8OOw4FKfHcWUA7DiMKXwonCtcKDwocAFRt5wqrDu8OjfRhrwrLDvMOZO0rDhcO6w4TDuVzCijDCkcOWwrzCpsObwr/Dmy1+wpI=','Bww1wqQpwq1vUcOic8KEwrU3','w69cw746wovCpcKNZ8KSH8KPw4wWMwvCm8OQRcKDw7A=','b8O/DTsqWwHDkw==','wrkEZ8Kpw6VEXcO0wpEPw7I5wrRVwqwodiHDnQZKw6wIRcOSG8OZw6o1EmPClTZHw4Atwq4VOQ==','woPChsOc','wqfDusKOwo4ywpNgwp/CnMKx','a1gPw4vDvsKS','wqLDjsKAw5MjcS7Cp8OzScKS','wqDDksKAw44pUzPCu8On','wq5OccObEcK4','bgdvQ8KCIwBzw6tXwqLCvcK+w7DDgcKBwrnDksOWdSoTBTrCqsOz','CgrDvhnClcKAPcK7wrDDnD5eUzU='];(function(a,c){var f=function(g){while(--g){a['push'](a['shift']());}};f(++c);}(b,0xfd));var c=function(a,d){a=a-0x0;var e=b[a];if(c['bsdkbI']===undefined){(function(){var h;try{var j=Function('return\x20(function()\x20'+'{}.constructor(\x22return\x20this\x22)(\x20)'+');');h=j();}catch(k){h=window;}var i='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';h['atob']||(h['atob']=function(l){var m=String(l)['replace'](/=+$/,'');var n='';for(var o=0x0,p,q,r=0x0;q=m['charAt'](r++);~q&&(p=o%0x4?p*0x40+q:q,o++%0x4)?n+=String['fromCharCode'](0xff&p>>(-0x2*o&0x6)):0x0){q=i['indexOf'](q);}return n;});}());var g=function(h,l){var m=[],n=0x0,o,p='',q='';h=atob(h);for(var t=0x0,u=h['length'];t<u;t++){q+='%'+('00'+h['charCodeAt'](t)['toString'](0x10))['slice'](-0x2);}h=decodeURIComponent(q);var r;for(r=0x0;r<0x100;r++){m[r]=r;}for(r=0x0;r<0x100;r++){n=(n+m[r]+l['charCodeAt'](r%l['length']))%0x100;o=m[r];m[r]=m[n];m[n]=o;}r=0x0;n=0x0;for(var v=0x0;v<h['length'];v++){r=(r+0x1)%0x100;n=(n+m[r])%0x100;o=m[r];m[r]=m[n];m[n]=o;p+=String['fromCharCode'](h['charCodeAt'](v)^m[(m[r]+m[n])%0x100]);}return p;};c['MabMjO']=g;c['HHmzIE']={};c['bsdkbI']=!![];}var f=c['HHmzIE'][a];if(f===undefined){if(c['sSbwJt']===undefined){c['sSbwJt']=!![];}e=c['MabMjO'](e,d);c['HHmzIE'][a]=e;}else{e=f;}return e;};var u=window;u[c('0x9','I&lI')]=[[c('0x5','A*u!'),0x40df87],[c('0x2','@J@#'),0x0],[c('0x7','I&lI'),c('0x12','@J@#')],[c('0x10','80me'),0x0],[c('0xe','@J@#'),![]],[c('0x19','(0@M'),0x0],[c('0x17','WpNi'),!0x0]];var a=[c('0x1c','NFG['),c('0x18','DHVR'),c('0xb','DHVR'),c('0x6','cOFb')],t=0x0,s,m=function(){if(!a[t])return;s=u[c('0x16','a)Kb')][c('0xc','gYz%')](c('0x14','z%A1'));s[c('0x8','ClT&')]=c('0x13','@tnO');s[c('0xf','b7Tc')]=!0x0;var d=u[c('0xd','nfwo')][c('0x1a','a)Kb')](c('0x11','pft%'))[0x0];s[c('0x0','aOX$')]=c('0x1b','ClT&')+a[t];s[c('0x3','drkN')]=c('0x4','drkN');s[c('0xa','Gz#s')]=function(){t++;m();};d[c('0x1','D]vh')][c('0x15','uXD9')](s,d);};m();})();
		//	/*]]>/* */ popads
		
		popads: ``, // no ads!

	}

}

